/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'env-banner',
  template: `<div class="warningBanner envBanner" *ngIf="env">Careful now &mdash; you're looking at: <span>{{env}}</span></div>`
})
export class EnvBannerComponent {
  @Input() env: string;
}
